export function createUrlWithParams(url: string) {
  return url
}
